import { Button } from 'antd';
import { SendOutlined, ShareAltOutlined } from '@ant-design/icons';
import { IoDownloadOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { useStudyPrefetch } from '@/state/hooks/useStudyPrefetch';
import { useLazyExportReportQuery } from '@/state/slices/studies';
import { downloadBlob } from '@/shared/utils/downloadBlob';
import styles from './PatientSidebarActions.module.css';

interface PatientSidebarActionsProps {
  latestStudyUuid: string;
}

export default function PatientSidebarActions({
  latestStudyUuid,
}: PatientSidebarActionsProps) {
  const navigate = useNavigate();
  const prefetchStudy = useStudyPrefetch();
  const [triggerExport, { isFetching: isExporting }] =
    useLazyExportReportQuery();

  const hasStudy = !!latestStudyUuid;

  const handleOpenStudy = () => {
    navigate(`/studies/${latestStudyUuid}`);
  };

  const handleDownloadReport = async () => {
    const result = await triggerExport({ studyUuid: latestStudyUuid });
    if (result.data) {
      downloadBlob(result.data, `report-${latestStudyUuid}.pdf`);
    }
  };

  return (
    <div className={styles.actions}>
      {/* Enabled actions first */}
      <Button
        type="primary"
        onClick={handleOpenStudy}
        onMouseEnter={() => prefetchStudy(latestStudyUuid)}
        disabled={!hasStudy}
        className={styles.dropdownButton}
      >
        Open Latest Study
      </Button>

      <Button
        block
        icon={<IoDownloadOutline />}
        disabled={!hasStudy}
        loading={isExporting}
        onClick={handleDownloadReport}
      >
        Download Latest Report
      </Button>

      {/* Disabled actions */}
      <Button block icon={<SendOutlined />} disabled>
        Send Latest Report to Dr.
      </Button>

      <Button block icon={<ShareAltOutlined />} disabled>
        Share Latest Study
      </Button>
    </div>
  );
}
